const Container = ({ children }) => {
    return <div className="menu-container">{children}</div>;
};

export default Container;